import React from "react";
import { Outlet, Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Menu from "../components/Menu";
import Slider from "../components/Slider";
import Player from "../components/Player";
import Inset from "../components/Inset";

const headerInsetUrl = "/content/blocks/header-inset.html";

const Layout = ({ content }) => {
  const channelsList =
    content && content.channels
      ? content.channels.map((channel, index) => (
          <li key={index}>
            <Link to={channel.url}>{channel.title}</Link>
          </li>
        ))
      : null;
  return (
    <>
      <Header content={content} />
      <Menu content={content} />
      <Inset contentUrl={headerInsetUrl} />
      <Slider content={content} />
      <Outlet />
      <Footer content={content} />
      <Player content={content} />
    </>
  );
};

export default Layout;
